import Header from '../components/Header/HeaderBanner'
import Footer from '../components/Footer'
import ProgressIndicator from '../components/ProgressIndicator/ProgressIndicator'
import { useDataContext } from '../context/DataProvider'
import { useCallback, useEffect, useState } from 'react'
import { ActivityLogEvent } from '../apis/requests/activity-log.request'
import Spinner from '../components/Spinner'
import { SubmitUserInfo } from '../apis/entities/candidate.entity'
import { API } from '../apis/API'
import { StyleUtil } from '../utils/StyleUtil'
import heroBanner from '../images/hero-banner.png'
import MentemMuiSelect from '../components/MentemMuiSelect'
import { MenuItem } from '@mui/material'
import { toastError } from '../utils/toast'

export default function End() {
  const {
    assessment,
    candidateId,
    postActivityLog,
    submitSelfAssessment,
    assessmentResult,
    isPublic,
  } = useDataContext()
  const [isLoading, setIsLoading] = useState(false)
  const [hasError, setHasError] = useState(false)
  const [isSubmitted, setIsSubmitted] = useState(false)

  const submitTest = useCallback(async () => {
    try {
      setIsLoading(true)
      await submitSelfAssessment()
      setIsSubmitted(true)
    } catch (error) {
      console.error(error)
      setHasError(true)
    } finally {
      setIsLoading(false)
    }
  }, [submitSelfAssessment])

  useEffect(() => {
    if (isPublic) {
    } else {
      if (!isSubmitted) {
        submitTest()
      }
    }
  }, [assessment, submitTest, isSubmitted, isPublic])

  // analytics
  useEffect(() => {
    if (candidateId) {
      // console.log('candidateId', candidateId)
      console.log('assessmentResult', assessmentResult.current)
      console.log(
        'focus area count:' + assessmentResult.current?.focusAreaResults.length,
      )
      console.log(
        'capability count:' +
          assessmentResult.current?.focusAreaResults.flatMap(
            (focusAreaResult) => focusAreaResult.capabilityResults,
          ).length,
      )
      console.log(
        'requirement count:' +
          assessmentResult.current?.focusAreaResults.flatMap(
            (focusAreaResult) =>
              focusAreaResult.capabilityResults.flatMap((capabilityResult) =>
                capabilityResult.proficiencyResults.flatMap(
                  (proficiencyResult) => proficiencyResult.requirementResults,
                ),
              ),
          ).length,
      )
      postActivityLog(ActivityLogEvent.visit, window.location.href)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [candidateId])

  const [userInfo, setUserInfo] = useState<SubmitUserInfo>({
    firstName: '',
    lastName: '',
    email: '',
    industry: '',
  })

  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = event.target

    setUserInfo((prevUserInfo) => ({ ...prevUserInfo, [name]: value }))
  }
  console.log('userInfo', userInfo)

  // Check if all required fields are valid
  const isFormValid = () => {
    const emailPattern = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
    return (
      userInfo.email.trim() !== '' &&
      emailPattern.test(userInfo.email) &&
      userInfo.industry !== ''
    )
  }
  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault()

    // Validate industry selection
    if (!userInfo.industry || userInfo.industry === '') {
      toastError('Please select an industry')
      return
    }

    // Basic email validation using a regular expression
    const emailPattern = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/

    if (!emailPattern.test(userInfo.email)) {
      toastError('Invalid email format')
      return
    }

    // You can perform further actions like sending the data to a server here
    console.log('User Info:', userInfo)

    await API.updateCandidate(
      candidateId,
      userInfo.firstName,
      userInfo.lastName,
      userInfo.email,
      userInfo.industry,
    )
    submitTest()

    // Reset the form
    // setUserInfo({ firstName: '', lastName: '', email: '' });
  }

  const industries = [
    'Accommodation and food services',
    'Administrative and support services',
    'Agriculture, forestry and fishing',
    'Arts and recreation services',
    'Construction',
    'Education and training', //(private)
    'Electricity, gas, water and waste services',
    'Health care and social assistance (private)',
    'Information media and telecommunications',
    'Manufacturing',
    'Mining',
    'Professional, scientific and technical services',
    'Public administration and safety', //(private)
    'Rental, hiring and real estate services',
    'Retail trade',
    'Transport, postal and warehousing',
    'Wholesale trade',
    'Other services',
  ]

  return (
    <div className="h-screen flex flex-col items-center">
      <div className="relative lg:max-w-[1000px] xl:max-w-[1200px] w-full h-full flex flex-col">
        <div className="bg-white grow">
          <div className="relative md:max-w-[800px] lg:max-w-[1000px] xl:max-w-[1200px] w-full mx-auto">
            <Header media={heroBanner} title={assessment?.title ?? ''} />
            <div className="flex justify-center pt-7">
              <ProgressIndicator />
            </div>
            {/* form */}
            {!isLoading && isPublic && !isSubmitted && (
              <div className="">
                <h1 className="text-4xl font-bold pt-6 px-1 mb-6">
                  We're calculating your results
                </h1>
                <div
                  className="text-center mx-auto mb-6"
                  style={{
                    // border: '1px solid #FFF',
                    background: '#f7f7f7',
                    boxShadow:
                      '0 542px 152px 0 rgba(0, 0, 0, 0.00), 0 347px 139px 0 rgba(0, 0, 0, 0.01), 0 195px 117px 0 rgba(0, 0, 0, 0.05), 0 87px 87px 0 rgba(0, 0, 0, 0.09), 0 22px 48px 0 rgba(0, 0, 0, 0.10)',
                    display: 'flex',
                    width: '718px',
                    padding: '36px 24px',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <div className="font-bold text-2xl mb-4">
                    Let us know where to email your results to
                  </div>
                  <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                    <div className="flex flex-row gap-2">
                      <div className="grow">
                        <input
                          className="block border border-grey-light w-full py-[6px] font-roboto px-3"
                          type="text"
                          id="firstName"
                          name="firstName"
                          placeholder="First name (Optional)"
                          value={userInfo.firstName}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div>
                      <input
                        className="block border border-grey-light w-full py-[6px] font-roboto px-3"
                        type="text"
                        id="email"
                        name="email"
                        placeholder="Business email"
                        value={userInfo.email}
                        onChange={handleInputChange}
                      />
                    </div>
                    <MentemMuiSelect
                      value={userInfo.industry || ''}
                      displayEmpty
                      sx={{
                        fontSize: '18px',
                        fontWeight: '400',
                        fontFamily: 'Clancy, sans-serif',
                        backgroundColor: 'white',
                        border: '1px solid #e5e5e5',
                        '& .MuiSelect-select': {
                          textAlign: 'center',
                          padding: '5px 12px',
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                          border: 'none',
                        },
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            '& .MuiList-root': {
                              paddingTop: 0,
                              paddingBottom: 0,
                              border: '1px solid #C8C8C8',
                            },
                            '& .MuiMenuItem-root': {
                              fontFamily: 'Clancy, sans-serif',
                              fontSize: '18px',
                              fontWeight: '400',
                              justifyContent: 'center',
                              whiteSpace: 'normal',
                              wordWrap: 'break-word',
                              '&:hover': {
                                backgroundColor: '#FFFAE2',
                              },
                              '&.Mui-selected': {
                                backgroundColor: '#FFFAE2',
                                '&:hover': {
                                  backgroundColor: '#FFFAE2',
                                },
                                '&.Mui-focusVisible': {
                                  backgroundColor: '#FFFAE2',
                                },
                              },
                              // '&.Mui-focusVisible': {
                              //   backgroundColor: '#FFFAE2',
                              // },
                            },
                          },
                        },
                      }}
                      onChange={(e) => {
                        setUserInfo((prevUserInfo) => ({
                          ...prevUserInfo,
                          industry: e.target.value,
                        }))
                      }}
                    >
                      <MenuItem value="">Please select your industry</MenuItem>
                      {industries.map((industry) => (
                        <MenuItem key={industry} value={industry}>
                          {industry}
                        </MenuItem>
                      ))}
                    </MentemMuiSelect>
                    <div>
                      <button
                        type="submit"
                        className={
                          isFormValid()
                            ? StyleUtil.buttonPrimaryUnsw
                            : StyleUtil.buttonWhiteToYellow
                        }
                      >
                        Submit
                      </button>
                    </div>
                    <div className="font-roboto text-left">
                      You will receive a personal report from{' '}
                      <b>no-reply@unsw.edu.au</b> - please check your email
                      inbox (or junk mail, just in case)
                    </div>
                    <div className="font-roboto text-sm text-left">
                      <b>Privacy:</b> Your personal information will only be
                      used for the purpose of this request. Specifically, your
                      email address will be used to deliver your personal
                      report. You are not giving UNSW consent to send follow-up
                      communication beyond this report. We do not share your
                      data with third parties without your consent. For more
                      information on how we handle your data, see our master{' '}
                      <a
                        className=""
                        href="https://www.unsw.edu.au/privacy"
                        target="_blank"
                        rel="opener noreferrer"
                      >
                        privacy policy
                      </a>{' '}
                      for more information.
                    </div>
                  </form>
                </div>
              </div>
            )}
            {isLoading && (
              <>
                <div className="flex justify-center">
                  <Spinner />
                </div>
                <div className="flex justify-center font-roboto">
                  Submitting the test...
                </div>
              </>
            )}

            {/* thank you message */}
            {!isLoading && isSubmitted && !hasError && (
              <>
                <h1 className="text-4xl font-bold pt-6 px-1">
                  Thanks for completing the test!
                </h1>
                <div className="font-roboto pt-6 px-1">
                  <p className="">
                    Thank you for taking the time to complete this placement
                    test. Your answers will help us in planning new short
                    courses and placing candidates at the right level. If you
                    have any questions about this test or want to learn more
                    about UNSW short courses and our programs, you can contact
                    us at{' '}
                    <a
                      className="text-purple-600"
                      href="mailto:support.agsm@unsw.edu.au"
                    >
                      support.agsm@unsw.edu.au
                    </a>
                    .
                  </p>
                </div>
              </>
            )}
            {hasError && (
              <>
                <h1 className="text-4xl font-bold pt-6 px-1">
                  Unable to submit the test
                </h1>
                <div className="font-roboto pt-6 px-1">
                  <p className="">
                    We apologize for the inconvenience, but it seems that we are
                    currently experiencing technical difficulties that prevent
                    us from processing the test at this time.
                  </p>
                </div>
              </>
            )}
            {!isPublic && (
              <div className="font-roboto pt-6 px-1">
                <p className="">
                  <span className="font-bold">Privacy: </span>This test does not
                  capture any identifying information. Your recommended starting
                  level will be shared with your organization, and your
                  responses may be used to help UNSW improve and develop the
                  test in the future. See our master{' '}
                  <a
                    className="text-purple-600"
                    href="https://www.unsw.edu.au/privacy"
                    target="_blank"
                    rel="opener noreferrer"
                  >
                    privacy policy
                  </a>{' '}
                  for more information.
                </p>
              </div>
            )}
            {/*{isPublic && (*/}
            {/*  <div className="font-roboto pt-6 px-1">*/}
            {/*    <p className="">*/}
            {/*      <span className="font-bold">Privacy: </span>*/}
            {/*      Your personal information will only be used for the purpose of*/}
            {/*      this request. Specifically, your email address will be used to*/}
            {/*      deliver your personal report. You are not giving UNSW consent*/}
            {/*      to send follow-up communication beyond this report. We do not*/}
            {/*      share your data with third parties without your consent. For*/}
            {/*      more information on how we handle your data, see our master{' '}*/}
            {/*      <a*/}
            {/*        className="text-purple-600"*/}
            {/*        href="https://www.unsw.edu.au/privacy"*/}
            {/*        target="_blank"*/}
            {/*        rel="opener noreferrer"*/}
            {/*      >*/}
            {/*        privacy policy*/}
            {/*      </a>{' '}*/}
            {/*      for more information.*/}
            {/*    </p>*/}
            {/*  </div>*/}
            {/*)}*/}
          </div>
        </div>
        <Footer />
      </div>
    </div>
  )
}
